import { render, staticRenderFns } from "./SystemConfigSpreadBuy.vue?vue&type=template&id=25478264&"
import script from "./SystemConfigSpreadBuy.vue?vue&type=script&lang=js&"
export * from "./SystemConfigSpreadBuy.vue?vue&type=script&lang=js&"
import style0 from "./SystemConfigSpreadBuy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports